import { useMemo } from 'react'

import { useTokenCatalog } from '@/data/marketApi/hooks/useTokenCatalog'
import { useUserAddedTokens } from '@/state/user/hooks'

import { ChainId, Currency } from '../../sdk'

import { buildVisibleCatalogCurrencies } from './swapCatalog'

/** Tokens visibles para UI: catálogo de producto + tokens importados (sin wrapped native). */
export function useSwapCatalogTokens(chainId: ChainId): Currency[] {
  const { entries } = useTokenCatalog()
  const userAddedTokens = useUserAddedTokens()

  return useMemo(
    () => buildVisibleCatalogCurrencies(chainId, entries, userAddedTokens),
    [chainId, entries, userAddedTokens],
  )
}
